import request from '@/utils/request'

// 查询社区小组帖子列表
export function listCommunityGroupPost(query) {
  return request({
    url: '/biz/admin/community/community/group/post/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组帖子分页
export function pageCommunityGroupPost(query) {
  return request({
    url: '/biz/admin/community/community/group/post/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组帖子详细
export function getCommunityGroupPost(data) {
  return request({
    url: '/biz/admin/community/community/group/post/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组帖子
export function addCommunityGroupPost(data) {
  return request({
    url: '/biz/admin/community/community/group/post/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组帖子
export function updateCommunityGroupPost(data) {
  return request({
    url: '/biz/admin/community/community/group/post/edit',
    method: 'post',
    data: data
  })
}

// 更新社区小组帖子推荐状态（广告位开关，只改 is_recommend）
export function updateCommunityGroupPostRecommend(data) {
  return request({
    url: '/biz/admin/community/community/group/post/recommend',
    method: 'post',
    data: data
  })
}

// 更新社区小组帖子置顶状态（后台置顶开关，只改 is_top）
export function updateCommunityGroupPostTop(data) {
  return request({
    url: '/biz/admin/community/community/group/post/top',
    method: 'post',
    data: data
  })
}

// 删除社区小组帖子
export function delCommunityGroupPost(data) {
  return request({
    url: '/biz/admin/community/community/group/post/delete',
    method: 'post',
    data: data
  })
}
